var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _c(
                      "v-expansion-panel",
                      {
                        attrs: { expand: "" },
                        model: {
                          value: _vm.panel,
                          callback: function($$v) {
                            _vm.panel = $$v
                          },
                          expression: "panel"
                        }
                      },
                      [
                        _c(
                          "v-expansion-panel-content",
                          [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { "d-flex": "", xs12: "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "itemVente",
                                        attrs: { row: "", wrap: "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              { attrs: { flat: "" } },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 grey--text text--darken-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$tc(
                                                              "sales",
                                                              2,
                                                              { count: "" }
                                                            ) + " chat"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline teal--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.nbSales)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              { attrs: { flat: "" } },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 grey--text text--darken-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$tc(
                                                              "items",
                                                              2,
                                                              { count: "" }
                                                            ) + " chat"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline blue--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.nbItems)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              { attrs: { flat: "" } },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 grey--text text--darken-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$t("amount") +
                                                              " chat"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline pink--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          Intl.NumberFormat(
                                                            _vm.lang,
                                                            {
                                                              style: "currency",
                                                              currency:
                                                                _vm.currency
                                                            }
                                                          ).format(_vm.nbAmount)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              { attrs: { flat: "" } },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 grey--text text--darken-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$t(
                                                              "averageBasket"
                                                            ) + " chat"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline deep-orange--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          Intl.NumberFormat(
                                                            _vm.lang,
                                                            {
                                                              style: "currency",
                                                              currency:
                                                                _vm.currency
                                                            }
                                                          ).format(
                                                            _vm.panierMoyen
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  dark: ""
                                                }
                                              },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 white--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$t(
                                                              "conversionRate"
                                                            ) + " chat"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline white--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.nbConversion
                                                        ) + " %"
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c(
                                              "v-card",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  dark: ""
                                                }
                                              },
                                              [
                                                _c("v-card-text", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 white--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "% du Chiffre d'Affaire total"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 headline white--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ratioChatTotal
                                                        ) + " %"
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card",
                              [
                                _c(
                                  "v-card-text",
                                  {},
                                  [
                                    _c("highcharts", {
                                      attrs: { options: _vm.options }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.brideMenu("stats_ventes_chatbot") === "1"
                          ? _c(
                              "v-expansion-panel-content",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { "d-flex": "", xs12: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "itemVente",
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "sales",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " chatbot"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline teal--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbSalesBot
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "items",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " chatbot"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline blue--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbItemsBot
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "amount"
                                                                ) + " chatbot"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline pink--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.nbAmountBot
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "averageBasket"
                                                                ) + " chatbot"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline deep-orange--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.panierMoyenBot
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "conversionRate"
                                                                ) + " chatbot"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbConversionBot
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "% du Chiffre d'Affaire total"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ratioBotTotal
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c(
                                      "v-card-text",
                                      {},
                                      [
                                        _c("highcharts", {
                                          attrs: { options: _vm.optionsChatBot }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brideMenu("parametre_connecteur_apz") === "1"
                          ? _c(
                              "v-expansion-panel-content",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { "d-flex": "", xs12: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "itemVente",
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "sales",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " visio"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline teal--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbSalesVisio
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "items",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " visio"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline blue--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbItemsVisio
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "amount"
                                                                ) + " visio"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline pink--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.nbAmountVisio
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "averageBasket"
                                                                ) + " visio"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline deep-orange--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.panierMoyenVisio
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "conversionRate"
                                                                ) + " visio"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbConversionVisio
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "% du Chiffre d'Affaire total"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ratioVisioTotal
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c(
                                      "v-card-text",
                                      {},
                                      [
                                        _c("highcharts", {
                                          attrs: { options: _vm.optionsVisio }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brideMenu("stats_ventes_callback") === "1"
                          ? _c(
                              "v-expansion-panel-content",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { "d-flex": "", xs12: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "itemVente",
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "sales",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " Call back"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline teal--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbSalesC2C
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$tc(
                                                                  "items",
                                                                  2,
                                                                  { count: "" }
                                                                ) + " Call back"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline blue--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbItemsC2C
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "amount"
                                                                ) + " Call back"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline pink--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.nbAmountC2C
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "averageBasket"
                                                                ) + " Call back"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline deep-orange--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Intl.NumberFormat(
                                                                _vm.lang,
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    _vm.currency
                                                                }
                                                              ).format(
                                                                _vm.panierMoyenC2C
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "conversionRate"
                                                                ) + " Call back"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbConversionC2C
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "% du Chiffre d'Affaire total"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ratioC2CTotal
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c(
                                      "v-card-text",
                                      {},
                                      [
                                        _c("highcharts", {
                                          attrs: { options: _vm.optionsC2C }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brideMenu("stats_ventes_lead") === "1"
                          ? _c(
                              "v-expansion-panel-content",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { "d-flex": "", xs12: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "itemVente",
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 grey--text text--darken-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Acquisitions Leads"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline teal--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbSalesLead
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 grey--text text--darken-2"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 headline blue--text"
                                                      })
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 grey--text text--darken-2"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 headline pink--text"
                                                      })
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c("v-card-text", [
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 grey--text text--darken-2"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "ml-4 headline deep-orange--text"
                                                      })
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs4: "" } },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "conversionRate"
                                                                ) + " Lead"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ml-4 headline white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nbConversionLead
                                                            ) + " %"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c(
                                      "v-card-text",
                                      {},
                                      [
                                        _c("highcharts", {
                                          attrs: { options: _vm.optionsLead }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "headline",
                            attrs: { xs6: "", sm10: "" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("cap")(_vm.$t("salesDetails")))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", sm2: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  slot: "activator",
                                  color: "primary",
                                  dark: "",
                                  flat: "",
                                  disabled: _vm.salesDetails.length == 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.download()
                                  }
                                },
                                slot: "activator"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("exportInCsv")) +
                                    "\n              "
                                ),
                                _c(
                                  "v-icon",
                                  { attrs: { color: "primary", right: "" } },
                                  [_vm._v("file_download")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headersSalesDetails,
                        items: _vm.salesDetails,
                        "no-data-text": _vm.$tc("sales", 0),
                        "no-results-text": _vm.$tc("results", 0),
                        "rows-per-page-items": [
                          10,
                          25,
                          50,
                          { text: "Toutes", value: -1 }
                        ],
                        "rows-per-page-text": _vm.$t("salesPerPage")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "headerCell",
                          fn: function(props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.header.text))])
                            ]
                          }
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [_vm._v(_vm._s(props.item.date))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.visitorId))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.saleId))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    Intl.NumberFormat(_vm.lang, {
                                      style: "currency",
                                      currency: _vm.currency
                                    }).format(props.item.amount)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.items))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.agent))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.canal))])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "headline",
                            attrs: { xs6: "", sm10: "" }
                          },
                          [_vm._v(_vm._s(_vm.$t("salesTad")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", sm2: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  slot: "activator",
                                  color: "primary",
                                  dark: "",
                                  flat: "",
                                  disabled: _vm.tagDetails.length == 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadtag()
                                  }
                                },
                                slot: "activator"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("exportInCsv")) +
                                    "\n              "
                                ),
                                _c(
                                  "v-icon",
                                  { attrs: { color: "primary", right: "" } },
                                  [_vm._v("file_download")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headersSalesDetailsTag,
                        items: _vm.tagDetails,
                        "no-data-text": _vm.$tc("sales", 0),
                        "no-results-text": _vm.$tc("results", 0),
                        "rows-per-page-items": [
                          10,
                          25,
                          50,
                          { text: "Toutes", value: -1 }
                        ],
                        "rows-per-page-text": _vm.$t("salesPerPage")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "headerCell",
                          fn: function(props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.header.text))])
                            ]
                          }
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [_vm._v(_vm._s(props.item.date))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.visitorId))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.saleId))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    Intl.NumberFormat(_vm.lang, {
                                      style: "currency",
                                      currency: _vm.currency
                                    }).format(props.item.amount)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.items))])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "headline",
                            attrs: { xs6: "", sm10: "" }
                          },
                          [_vm._v("Push produit : mise au panier")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headersPushProduct,
                        items: _vm.pushDetails,
                        "no-data-text": _vm.$tc("sales", 0),
                        "no-results-text": _vm.$tc("results", 0),
                        "rows-per-page-items": [
                          10,
                          25,
                          50,
                          { text: "Toutes", value: -1 }
                        ],
                        "rows-per-page-text": _vm.$t("salesPerPage")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "headerCell",
                          fn: function(props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.header.text))])
                            ]
                          }
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [_vm._v(_vm._s(props.item.date))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.visitorId))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.productId))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.agent))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.success))])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22dbd0c8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dbd0c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Sales.vue
// module id = null
// module chunks = 